/**
 * How a delivered file should be presented: looked at, or downloaded.
 *
 * Lives apart from `OpenDocument.tsx` because that module exports components;
 * a non-component export there breaks React Fast Refresh in dev
 * (`react-refresh/only-export-components`).
 */

/**
 * Extensions stored with a real image Content-Type and NO
 * `Content-Disposition`, so their presigned URL renders in the browser rather
 * than downloading (verified against a generated `studio/**.png` in prod:
 * `image/png`, disposition absent). Documents are the opposite — `text/plain`
 * + `attachment` — so they keep the download affordance.
 */
const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp'] as const;

/** True when `name` is one of the inline-rendering image types. */
export function isImageName(name: string): boolean {
  const ext = name.split('.').pop()?.toLowerCase() ?? '';
  return (IMAGE_EXTENSIONS as readonly string[]).includes(ext);
}
